import { createTheme } from 'uiKit/atoms/styles/styles';
import type { Theme } from 'uiKit/atoms/styles/styles';
import { commonPaletteConfig, commonTypographyConfig, commonComponentsConfig } from './themeConfig';

const createAppTheme = (mode: 'light' | 'dark'): Theme => {
  const palette = {
    mode,
    ...commonPaletteConfig,
  };

  const theme = createTheme({
    palette,
    typography: commonTypographyConfig,
  });

  theme.components = commonComponentsConfig(theme.palette);

  return theme;
};

export const lightTheme: Theme = createAppTheme('light');
export const darkTheme: Theme = createAppTheme('dark');

export const getThemeByMode = (mode: string): Theme => {
  if (mode === 'dark') {
    return darkTheme;
  }
  return lightTheme;
};
